export const DefaultConfigs = Object.freeze({
  TickSize: 15,
  TickLabelExtraSpaceForSup: 1,
  LabelSpaceForSup: 8,

  XAxis: {
    x: 0,
    y: 80,
    rotate: 0,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "500",
    textAnchor: "middle",
    textColor: "#000",
  },

  YAxis: {
    x: 0,
    y: -50,
    rotate: -90,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "500",
    textAnchor: "middle",
    textColor: "#000",

    arrow: {
      fontFamily: "Roboto",
      fontSize: "12px",
      labelShift: 0,
      dotRadius: 4,
      edgeSize: 40,
      edgeShift: 5,
    },
  },

  XAxisTicks: {
    font: "400 12px Roboto",
    textColor: "#2B2B2B",
  },

  XAxisOriginLabel: {
    font: "400 12px Roboto",
    textColor: "#2B2B2B",
    textAnchor: "middle",
  },

  YAxisTicks: {
    font: "500 12px Roboto",
    textColor: "#2B2B2B",
  },

  TrendLines: {
    fontFamily: "Roboto, sans-serif",
    fontSize: 14,
    textAnchor: "start",
    textColor: "#000",
    textMargin: 8,
    lineType: "solid",
    lineColor: "#000",
  },

  LineChart: {
    dotRadius: 8,
    extremeWidth: 15,
    strokeWidth: 1,

    lineLabel: {
      fontFamily: "Roboto, sans-serif",
      fontSize: 10,
    },

    shadedRegion: {
      fontFamily: "Roboto, sans-serif",
      fontSize: 14,
    },
  },

  DotplotChart: {
    dotRadius: 5,
  },

  BoxplotChart: {
    outlierRadius: 2.5,
    outlierShift: 16,
    outlierStrokeWidth: 1.5,
    boxWidth: 90,
    extremeWidth: 60,
    boxStrokeWidth: 2,
    extremeStrokeWidth: 1.5,
    meanStrokeWidth: 2.5,
    meanRadius: 3,
  },

  BarChart: {
    barLabel: {
      font: "12px Roboto",
    },
    xAxis: {
      tickSize: 0,
      labelSpace: 16,
    },
  },
});

export const IPadProConfigs = Object.freeze({
  ...DefaultConfigs,

  TickLabelExtraSpaceForSup: 3,
  LabelSpaceForSup: 10,

  XAxis: {
    ...DefaultConfigs.XAxis,
    fontSize: 18,
  },

  YAxis: {
    ...DefaultConfigs.YAxis,
    fontSize: 18,
    arrow: {
      ...DefaultConfigs.YAxis.arrow,
      fontSize: "15px",
    },
  },

  XAxisTicks: {
    ...DefaultConfigs.XAxisTicks,
    font: "400 15px Roboto",
  },

  XAxisOriginLabel: {
    ...DefaultConfigs.XAxisOriginLabel,
    font: "400 15px Roboto",
  },

  YAxisTicks: {
    ...DefaultConfigs.YAxisTicks,
    font: "500 14px Roboto",
  },

  TrendLines: {
    ...DefaultConfigs.TrendLines,
    fontSize: 16,
  },

  LineChart: {
    ...DefaultConfigs.LineChart,

    lineLabel: {
      ...DefaultConfigs.LineChart.lineLabel,
      fontSize: 12,
    },

    shadedRegion: {
      ...DefaultConfigs.LineChart.shadedRegion,
      fontSize: 16,
    },
  },

  BoxplotChart: {
    outlierRadius: 3.5,
    meanRadius: 4,
  },

  BarChart: {
    ...DefaultConfigs.BarChart,
    barLabel: {
      ...DefaultConfigs.BarChart.barLabel,
      font: "14px Roboto",
    },
  },
});
